<div class="container">
  <div class="main-layout">
    <aside>
      <div class="logo">
        <img src="assets/logo_big.svg" alt="Logo" />
      </div>
      <app-menu></app-menu>
    </aside>

    <div class="w-100">
      <nav>
        <div>
          @if (featureTitleKey$ | async; as titleKey) {
            <h1>
              {{ titleKey | translate }}
            </h1>
          }
        </div>
        <div class="flex gap-3 align-items-center">
          @if (loggedUser$ | async; as user) {
            <div class="user-info">
              <h6 class="mb-0">{{ user | fullName }}</h6>
              <img
                class="avatar"
                [src]="user.avatarUrl | replaceEmptyAvatar"
                alt="avatar" />
            </div>
          }
          <p-button
            class="md:hidden"
            icon="pi pi-bars"
            [rounded]="true"
            [text]="true"
            (click)="visibleDrawer = true" />
        </div>
      </nav>

      <main>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>

<!--Drawer-->
<p-drawer
  #drawerRef
  [(visible)]="visibleDrawer"
  appendTo="body"
  [fullScreen]="true"
  [blockScroll]="true">
  <ng-template #headless>
    <div class="flex flex-column">
      <div class="flex gap-3 justify-content-between p-3">
        <div class="logo">
          <img src="assets/logo_big.svg" alt="Logo" />
        </div>

        <p-button
          icon="pi pi-times"
          [rounded]="true"
          size="small"
          [text]="true"
          (click)="visibleDrawer = false" />
      </div>

      <div class="pt-2">
        <app-menu (redirected)="visibleDrawer = false"></app-menu>
      </div>
    </div>
  </ng-template>
</p-drawer>
